import '../scss/Divider.scss';

function Divider({ type, margin }) {
  if (type === 'vertical') {
    return (
      <div className="ui-vertical-divider" style={{ margin }} />
    );
  }
  return (
    <div className="ui-divider" />
  );
}
export default Divider;
